<!--suppress CssUnusedSymbol -->
<template>
    <v-app-bar
                app
                fixed
                height="50"
                >
                <v-app-bar-nav-icon
                @click.stop="toggleLeftDrawer()"
                />
                <v-toolbar-title
                class="ml-0"
                id="toolbarTitle"
                v-if="$vuetify.breakpoint.mdAndUp"
                >
                {{ systemName }}
                </v-toolbar-title>
                <v-spacer />
        <v-btn
            @click="toggleRightDrawer"
            class="text-none font-weight-regular"
            color="primary"
            depressed
            v-if="$vuetify.breakpoint.mdAndUp"
        >
            <v-icon
                size="16"
                style="margin-right:5px"
            >fa-user
            </v-icon>
            {{ userProfile.name }}
        </v-btn>
        <v-btn
            @click="toggleRightDrawer"
            class="text-none font-weight-regular"
            color="primary"
            depressed
            icon
            v-else
        >
            <v-icon
                color="white"
                size="16"
                style="margin-right:5px"
            >fa-user
            </v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { TOGGLE_LEFT_DRAWER, TOGGLE_RIGHT_DRAWER } from "@/store/this_app/mutations";
import { mapGetters } from "vuex";

import authentication from './../authentication';

export default {
    name: "TheToolbar",

    components: {
    },

    data: () => ({
        systemName: process.env.VUE_APP_SYSTEM_NAME,
        }),

        computed: {
            ...mapGetters(
            ["userProfile"]
            ),
        },
        methods: {
            logOut() {
                authentication.signOut();
            },
            toggleLeftDrawer() {
                this.$store.commit(TOGGLE_LEFT_DRAWER);
            },
            toggleRightDrawer() {
                this.$store.commit(TOGGLE_RIGHT_DRAWER);
            }
        }
    }
</script>

<style scoped>
</style>
